/**
 * Quản lý trạng thái tập trung cho Multiplane 2.5D Studio
 */
export const state = {
  // Trạng thái ứng dụng
  currentStyleKey: 'ghibli',
  currentCameraType: 'orthographic', // 'perspective' | 'orthographic'
  currentCameraMode: 'parallax', // 'parallax' | 'orbit' | 'side'
  currentPavement: 'terrazzo', // 'terrazzo' | 'stone' | 'asphalt'
  pavementRepeat: 12,
  zSpacingFactor: 1.0,
  isAutoSway: true,

  // Chiều cao mặt sàn & Điều khiển camera thủ công
  currentFloorHeight: 0.0,
  manualCamZoom: 1.0,
  manualCamHeight: 2.8,
  manualCamPanX: 0.0,

  // Chuột & tương tác
  mouse: { x: 0, y: 0, targetX: 0, targetY: 0 },

  // Nhân vật Voxel 3D
  currentAvatar: null,
  currentAvatarId: 'CO_GAI_AO_DAI',
  currentAnimName: 'walk',

  // Three.js Core
  canvas: null,
  scene: null,
  renderer: null,
  orthoCamera: null,
  perspCamera: null,
  controls: null,
  frustumHeight: 11.2,
  frameShiftY: 1.6,

  // Ánh sáng
  ambientLight: null,
  dirLight: null,
  cyanPointLight: null,
  magentaPointLight: null,
  lanternPointLight: null,

  // Layers 2.5D & meshes
  bgMat: null,
  bgMesh: null,
  fgMat: null,
  fgMesh: null,
  modularTownGroup: null,
  contactShadowGroup: null,
  modularHouseMeshes: [],
  seamCoverPole: null,
  layerCenterGroup: null,
  groundGroup: null,
  sidewalkMat: null,
  sidewalkMesh: null,
  curbMesh: null,
  roadMesh: null,
  propsGroup: null,
  pavementTextures: {
    terrazzo: null,
    stone: null,
    asphalt: null
  },

  // Quản lý Dự án (Project Explorer & Save)
  projectsList: [],
  selectedProjectFilename: null,
  currentProjectFilter: 'all',
  currentSearchKeyword: '',
  activeLoadedProject: null,
  currentCapturedThumb: null,
  deleteTargetFilename: null,
  deleteTargetName: null,
  isUserEditingFilename: false
};
